module.exports = __webpack_public_path__ + "static/costa-logo-f940414db0855baaa302790a816c40c3.png";